import { __exports as fetcher } from "../../../../../../../_virtual/fetcher2.js";
import { __require as requireVersion } from "../../../gen/version.js";
import { __require as requireHttp } from "../../transport/http.js";
import { __require as requireConfig } from "../../types/config.js";
import { __require as requireLoglevel } from "../../types/loglevel.js";
import { __require as requireLogger } from "../../util/logger.js";
import { __require as requireThreading } from "../../util/threading.js";
import { __require as requireTime } from "../../util/time.js";
import { __require as requireCohortApi } from "./cohort-api.js";
var hasRequiredFetcher;
function requireFetcher() {
  if (hasRequiredFetcher) return fetcher;
  hasRequiredFetcher = 1;
  (function(exports$1) {
    var __awaiter = fetcher && fetcher.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.CohortFetcher = exports$1.COHORT_CONFIG_TIMEOUT = void 0;
    const version_1 = requireVersion();
    const http_1 = requireHttp();
    const config_1 = requireConfig();
    const loglevel_1 = requireLoglevel();
    const logger_1 = requireLogger();
    const threading_1 = requireThreading();
    const time_1 = requireTime();
    const cohort_api_1 = requireCohortApi();
    exports$1.COHORT_CONFIG_TIMEOUT = 2e4;
    const ATTEMPTS = 3;
    class CohortFetcher {
      constructor(apiKey, secretKey, httpClient, serverUrl = config_1.CohortSyncConfigDefaults.cohortServerUrl, maxCohortSize = config_1.CohortSyncConfigDefaults.maxCohortSize, cohortRequestDelayMillis = 100, logLevel = loglevel_1.LogLevel.Error, loggerProvider = new logger_1.ConsoleLogger()) {
        this.inProgressCohorts = {};
        this.mutex = new threading_1.Mutex();
        this.executor = new threading_1.Executor(4);
        this.cohortApi = new cohort_api_1.SdkCohortApi(Buffer.from(apiKey + ":" + secretKey).toString("base64"), serverUrl, new http_1.WrapperClient(httpClient));
        this.maxCohortSize = maxCohortSize;
        this.cohortRequestDelayMillis = cohortRequestDelayMillis;
        this.logger = new logger_1.AmplitudeLogger(logLevel, loggerProvider);
      }
      static getKey(cohortId, lastModified) {
        return `${cohortId}_${lastModified ? lastModified : ""}`;
      }
      fetch(cohortId, lastModified) {
        return __awaiter(this, void 0, void 0, function* () {
          const unlock = yield this.mutex.lock();
          const key = CohortFetcher.getKey(cohortId, lastModified);
          if (!this.inProgressCohorts[key]) {
            this.inProgressCohorts[key] = this.executor.run(() => __awaiter(this, void 0, void 0, function* () {
              this.logger.debug("Start downloading", cohortId);
              for (let i = 0; i < ATTEMPTS; i++) {
                try {
                  const cohort = yield this.cohortApi.getCohort({
                    libraryName: "experiment-node-server",
                    libraryVersion: version_1.version,
                    cohortId,
                    maxCohortSize: this.maxCohortSize,
                    lastModified,
                    timeoutMillis: exports$1.COHORT_CONFIG_TIMEOUT
                  });
                  const unlock2 = yield this.mutex.lock();
                  delete this.inProgressCohorts[key];
                  unlock2();
                  this.logger.debug("Stop downloading", cohortId);
                  return cohort;
                } catch (e) {
                  if (i === ATTEMPTS - 1 || e instanceof cohort_api_1.CohortMaxSizeExceededError || e instanceof cohort_api_1.CohortClientRequestError) {
                    const unlock2 = yield this.mutex.lock();
                    delete this.inProgressCohorts[key];
                    unlock2();
                    throw e;
                  }
                  yield (0, time_1.sleep)(this.cohortRequestDelayMillis);
                }
              }
            }));
          }
          const cohortPromise = this.inProgressCohorts[key];
          unlock();
          return cohortPromise;
        });
      }
    }
    exports$1.CohortFetcher = CohortFetcher;
  })(fetcher);
  return fetcher;
}
export {
  requireFetcher as __require
};
//# sourceMappingURL=fetcher.js.map
